import type { DmPracticeOption } from '../../../../../services/practiceDm';

export function dmPracticePlace(practice: DmPracticeOption): string {
    const place = [practice.city, practice.countryCode].filter(Boolean).join(', ');
    return place || 'No location in DM';
}
